import { VehicleCategory } from './enums';

/**
 * Fahrzeugschemata fuer die Schadensmarkierung.
 * Die Bilder stammen unveraendert aus den Original-Word-Vorlagen
 * (Uebergabeprotokoll PKW.docx / Uebergabeprotokoll LCV.docx), damit das digitale
 * Protokoll optisch deckungsgleich mit dem bisherigen Papierformular ist.
 */
export interface Schematic {
  id: string;
  label: string;
  /** Dateiname unter assets/schematics/ bzw. /api/assets/schematics/ */
  file: string;
  width: number;
  height: number;
}

export const SCHEMATICS: Record<VehicleCategory, Schematic[]> = {
  PKW: [
    {
      id: 'pkw_uebersicht',
      label: 'PKW – alle Ansichten',
      file: 'pkw-ansichten.png',
      width: 500,
      height: 500,
    },
  ],
  LCV: [
    {
      id: 'lcv_ansichten',
      label: 'Nutzfahrzeug – Front / Heck / Seiten',
      file: 'lcv-ansichten.jpg',
      width: 1149,
      height: 617,
    },
    {
      id: 'lcv_draufsicht',
      label: 'Nutzfahrzeug – Draufsicht',
      file: 'lcv-draufsicht.jpg',
      width: 353,
      height: 697,
    },
  ],
};

export function schematicsFor(category: VehicleCategory): Schematic[] {
  return SCHEMATICS[category];
}

export function findSchematic(id: string): Schematic | undefined {
  return Object.values(SCHEMATICS).flat().find((s) => s.id === id);
}
